import { render, staticRenderFns } from "./AddDiscount.vue?vue&type=template&id=7dad551a&scoped=true"
import script from "./AddDiscount.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddDiscount.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./AddDiscount.vue?vue&type=style&index=0&id=7dad551a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dad551a",
  null
  
)

export default component.exports